export default "__VITE_ASSET__9QRfbX3C__"